import { useState } from 'react';
import OrganizationStaffData from './OrganizationStaffData';

const useOrganizationStaffData = () => {
  const [ organizationStaffState, setOrganizationStaffState ] = useState(OrganizationStaffData.INITIAL_STATE);

  const deleteOrganizationStaff = (personOrgRoleDurationId) => {
    return OrganizationStaffData.deleteOrganizationStaffData(personOrgRoleDurationId, organizationStaffState, setOrganizationStaffState);
  };

  return {
    organizationStaffState,
    deleteOrganizationStaff
  }
}

export default useOrganizationStaffData;
